import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// api
import ApiKey from '../../api/ApiKey';
import BaseApi from '../../api/BaseApi';
// components
import NavBar from '../../element/NavBar';
import Footer from '../../element/Footer';
import TitleBar from './components/TitleBar';
import MainSearchSection from './components/MainSearchSection';
import SearchResultsList from './components/SearchResultsList';
import AdvancedSearchSection from './components/AdvancedSearchSection';
import SelectedSearchFiltersBar from './components/SelectedSearchFiltersBar';
// helpers
import {CandidatesSearchPanel} from './candidates-search-panel/search-panel'

import { logOutIfTokenExpired } from '../../helpers';

const Jobseekers = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');
  
  const [loading, setLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [cvListData, setCvListData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [smallLoading, setSmallLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    keyword: '',
    searchAgeTo: '',
    searchGender: [],
    searchAgeFrom: '',
    searchLocation: [],
    searchLogic: 'all',
    searchIndustry: [],
    searchSalaryTo: '',
    searchWorkType: [],
    searchEducation: [],
    searchExperience: [],
    searchSalaryFrom: '',
    sortValue: 'newFirst',
    searchPlace: ['titles'],
    searchSalaryCurrency: '',
    resultsPeriod: 'allTime',
    searchDriverCategories: [],
    searchDriverLicense: false,
    searchRegions: [{ country: null, cities: [] }],
    searchLanguages: [{ lng: null, lng_skill: null }],
    searchCategories: [{ category: null, sub_categories: [] }],
  });

  const { keyword, cvList = [] } = cvListData;

  const jobsPerPage = 20;

  const totalPages = Math.ceil(totalCount / jobsPerPage);

  const handlePageChange = async page => {
    try {
      const positionNumber = page * jobsPerPage - jobsPerPage;

      setLoading(true);
      setCurrentPage(page);

      const response = await axios.post(
        BaseApi + '/candidates/listing',
        { ...searchParams, positionFrom: positionNumber },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      setLoading(false);
      setCvListData(response.data.response);
      setTotalCount(response.data.response.totalCount);
    } catch (error) {
      setLoading(false);

      console.error('Error fetching Jobseeker List', error);
    }
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/candidates/listing',
        searchParams,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      setLoading(false);
      setCurrentPage(1);
      setCvListData(response.data.response);
      setTotalCount(response.data.response.totalCount);
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Could not get data', error);
    }
  };

  const getDataWithSmallLoading = async () => {
    try {
      setSmallLoading(true);

      const response = await axios.post(
        BaseApi + '/candidates/listing',
        searchParams,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      setCurrentPage(1);
      setSmallLoading(false);
      setCvListData(response.data.response);
      setTotalCount(response.data.response.totalCount);
    } catch (error) {
      setSmallLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Could not get data', error);
    }
  };

  useEffect(() => {
    if (userType === 'candidate' || !tokenKey) {
      navigate('/auth/employer-login');
    } else {
      getData();
      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  useEffect(() => {
    getDataWithSmallLoading();
  }, [searchParams]); // eslint-disable-line

  return (
    <>
      <NavBar />
      {
        loading
          ? (
            <div className='loader-container'></div>
          ) : (
            <>
              <div className='jobseekerListing'>
                <CandidatesSearchPanel
                  onClear={()=> {
                     setSearchParams(prev=>({...prev, keyword: ''}))
                  }}
                  onSearchApply={(keyword)=> {
                     setSearchParams(prev=>({...prev, keyword: keyword}))
                  }}
                />
                {/* <MainSearchSection searchParams={searchParams} setSearchParams={setSearchParams} /> */}
                <div className='jobseekerSearchResults container'>
                  <TitleBar
                    title={keyword}
                    searchResults={totalCount}
                  />
                  <SelectedSearchFiltersBar
                    setLoading={setLoading}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                  />
                  <div className='row'>
                    <AdvancedSearchSection
                      setLoading={setLoading}
                      searchParams={searchParams}
                      setSearchParams={setSearchParams}
                    />
                    <SearchResultsList
                      cvList={cvList}
                      totalPages={totalPages}
                      currentPage={currentPage}
                      smallLoading={smallLoading}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
              <Footer />
            </>
          )
      }
    </>
  );
};

export default Jobseekers;
